import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchDietByPatientId, deleteDietById } from "../../../redux/actions/dietActions";
import { fetchPatients } from "../../../redux/actions/relatedEntitiesActions";
import { clearDiets } from "../../../redux/slices/dietSlice";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Accordion from "../../../components/Accordion/Accordion";
import Select from "react-select";
import Pagination from "../../../components/Pagination/Pagination";
import { MdHome, MdDelete, MdEdit } from "react-icons/md";
import { useModalFeedback } from "../../../context/ModalContext";
import '../styles/GetDiet.css';

import ico1 from '../../../assets/img/shortcut_icon/dietIco2.png';
import ico2 from '../../../assets/img/shortcut_icon/dietIco3.png';
import ico3 from '../../../assets/img/shortcut_icon/dietIco1.png';
import ico4 from '../../../assets/img/shortcut_icon/dietIco4.png';
import ico5 from '../../../assets/img/shortcut_icon/dietIco5.png';
import ico6 from '../../../assets/img/shortcut_icon/dietIco6.png';
import ico7 from '../../../assets/img/shortcut_icon/dietIco7.png';

function GetDietByPatientId() {
  const dispatch = useDispatch();
  const { diet_id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();


  const [dietIdToDelete, setDietIdToDelete] = useState({
    id: null,
    name: ''
  });

  const { showInfo, showConfirmation, setIsDeleting, hideModal } = useModalFeedback();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [selectedPatient, setSelectedPatient] = useState(null);

  // Seletores do Redux
  const { patients = [], loadingPatients, errorPatients } = useSelector((state) => state.relatedEntities || { patients: [] });
  const { diets = [], loadingDiets, errorDiets } = useSelector((state) => state.diets || { diets: [] });

  // Paginação
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const dietList = Array.isArray(diets) ? diets : [];
  const currentItems = dietList.slice(indexOfFirstItem, indexOfLastItem);
  const [hasSearched, setHasSearched] = useState(false);

  // useEffect(() => {
  //   console.log("Diets carregadas:", diets);
  // }, [diets]);

  useEffect(() => {
    return () => {
      dispatch(clearDiets()); // quando sair da página, limpa
    };
  }, [dispatch]);

  // Carregar pacientes ao montar o componente
  useEffect(() => {
    dispatch(fetchPatients());
  }, [dispatch]);

  // useEffect(() => {
  //   console.log("Pacientes carregados:", patients);
  // }, [patients]);

  // Se houver um paciente vindo da navegação, carregamos suas dietas
  useEffect(() => {
    const patientIdFromState = location.state?.patient_id;
    if (patientIdFromState) {
      setSelectedPatient({ value: patientIdFromState, label: "Paciente Selecionado" });
      dispatch(fetchDietByPatientId(patientIdFromState));
    } else {
      dispatch(clearDiets());
    }
  }, [location.state, dispatch]);

  if (!Array.isArray(diets)) {
    console.error("Erro: diets não é um array", diets);
    return <div>Erro ao carregar dietas. Tente novamente.</div>;
  }


  const handleDelete = (diet_id) => {
    showConfirmation(
      "Deseja realmente remover esse registro ?",
      async () => {
        setIsDeleting(true);
        try {
          await dispatch(deleteDietById(diet_id)).unwrap();
          if (selectedPatient && selectedPatient.value) {
            dispatch(fetchDietByPatientId(selectedPatient.value));
          }
          showInfo(`Dieta: ${formatDietName(diet_id.name)} removida com sucesso!`)
        } catch (error) {
          showInfo(`Erro ao tentar deletar a dieta: ${error}`, 3000);
        } finally {
          setIsDeleting(false);
        }
      },
      hideModal
    );
  };


  // Função para deletar uma dieta
  const handledeleteDietByIdById = async (diet_id) => {
    if (window.confirm("Tem certeza que deseja excluir esta dieta?")) {
      try {
        await dispatch(deleteDietById(diet_id)).unwrap();

        // Atualiza a lista após deletar a dieta
        if (selectedPatient && selectedPatient.value) {
          dispatch(fetchDietByPatientId(selectedPatient.value));
        }
      } catch (error) {
        console.error("Erro ao deletar dieta:", error);
        alert("Erro ao deletar dieta. Tente novamente.");
      }
    }
  };
  const formatDietGroup = (group) => {
    switch (group) {
      case 'weightLoss':
        return 'Perda de Peso';
      case 'weightGain':
        return 'Ganho de Peso';
      case 'generalHealth':
        return 'Saúde Geral';
      case 'vegetarianLifestyles':
        return 'Estilos Vegetarianos';
      case 'healthSpecific':
        return 'Saúde Específica';
      default:
        return 'Outros';
    }
  };

  // Formatar data no padrão DD/MM/YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "Data inválida";
    const date = new Date(dateString);
    return date.toLocaleDateString("pt-BR");
  };
  const formatDietName = (diet_name) => {
    switch (diet_name) {
      case 'low_carb':
        return 'Dieta Low Carb';
      case 'keto':
        return 'Dieta Cetogênica';
      case 'caloric_deficit':
        return 'Dieta de Déficit Calórico';
      case 'intermittent_fasting':
        return 'Dieta do Jejum Intermitente';
      case '21_day_diet':
        return 'Dieta de 21 Dias';
      case 'detox':
        return 'Dieta Detox';
      case '7_day_detox':
        return 'Dieta Detox de 7 Dias';
      case 'hypercaloric':
        return 'Dieta Hipercalórica';
      case 'hypertrophic':
        return 'Dieta Hipertófica';
      case 'bulking':
        return 'Dieta Bulking';
      case 'protein_diet':
        return 'Dieta da Proteína';
      case 'lean_gain':
        return 'Dieta para Ganho Lean (Massa Magra)';
      case 'mediterranean':
        return 'Dieta Mediterrânea';
      case 'mediterranean_adapted':
        return 'Dieta Mediterrânea Adaptada';
      case 'antiinflammatory':
        return 'Dieta Antiinflamatória';
      case 'antioxidant':
        return 'Dieta Antioxidante';
      case 'high_fiber':
        return 'Dieta Rica em Fibras';
      case 'cardiovascular':
        return 'Dieta de Saúde Cardiovascular';
      case 'immune_boost':
        return 'Dieta para Imunidade';
      case 'vegan':
        return 'Dieta Vegana';
      case 'vegetarian':
        return 'Dieta Vegetariana';
      case 'flexitarian':
        return 'Dieta Flexitariana';
      case 'pescatarian':
        return 'Dieta Pescetariana';
      case 'paleo':
        return 'Dieta Paleo';
      case 'dash':
        return 'Dieta DASH (Hipertensão)';
      case 'fodmap':
        return 'Dieta FODMAP (Distúrbios Intestinais)';
      case 'diabetes':
        return 'Dieta para Diabetes';
      case 'low_sodium':
        return 'Dieta Hipossódica';
      case 'renal':
        return 'Dieta Renal (Insuficiência Renal)';
      default:
        return '';
    }
  };

  const availableDiets = {
    weightLoss: [
      { value: 'low_carb', label: 'Dieta Low Carb', objective: 'Reduzir carboidratos para perda de peso.' },
      { value: 'keto', label: 'Dieta Cetogênica', objective: 'Induzir cetose para queima de gordura.' },
      { value: 'caloric_deficit', label: 'Dieta de Déficit Calórico', objective: 'Reduzir calorias para emagrecimento sustentável.' },
      { value: 'intermittent_fasting', label: 'Dieta do Jejum Intermitente', objective: 'Focar em períodos de jejum para regulação metabólica.' },
      { value: '21_day_diet', label: 'Dieta de 21 Dias', objective: 'Plano temporário para perda de peso rápida.' },
      { value: 'detox', label: 'Dieta Detox', objective: 'Eliminação de toxinas e renovação celular.' },
      { value: '7_day_detox', label: 'Dieta Detox de 7 Dias', objective: 'Renovação do corpo com alimentos leves e saudáveis.' },
    ],
    weightGain: [
      { value: 'hypercaloric', label: 'Dieta Hipercalórica', objective: 'Aumentar o consumo calórico para ganho de peso.' },
      { value: 'hypertrophic', label: 'Dieta Hipertófica', objective: 'Foco no ganho de massa muscular e hipertrofia.' },
      { value: 'bulking', label: 'Dieta Bulking', objective: 'Ganho de peso em preparação para hipertrofia.' },
      { value: 'protein_diet', label: 'Dieta da Proteína', objective: 'Aumentar o consumo de proteínas para ganho muscular.' },
      { value: 'lean_gain', label: 'Dieta para Ganho Lean (Massa Magra)', objective: 'Ganho de massa magra com pouca gordura.' },
    ],
    generalHealth: [
      { value: 'mediterranean', label: 'Dieta Mediterrânea', objective: 'Saúde geral baseada na culinária mediterrânea.' },
      { value: 'mediterranean_adapted', label: 'Dieta Mediterrânea Adaptada', objective: 'Promover saúde cardiovascular com alimentos integrais.' },
      { value: 'antiinflammatory', label: 'Dieta Antiinflamatória', objective: 'Reduzir inflamações com alimentos funcionais.' },
      { value: 'antioxidant', label: 'Dieta Antioxidante', objective: 'Melhorar a saúde celular com antioxidantes.' },
      { value: 'high_fiber', label: 'Dieta Rica em Fibras', objective: 'Aumentar a ingestão de fibras para saúde digestiva.' },
      { value: 'cardiovascular', label: 'Dieta de Saúde Cardiovascular', objective: 'Proteger o coração com alimentos saudáveis.' },
      { value: 'immune_boost', label: 'Dieta para Imunidade', objective: 'Fortalecer o sistema imunológico.' },
    ],
    vegetarianLifestyles: [
      { value: 'vegan', label: 'Dieta Vegana', objective: 'Estilo de vida sem consumo de alimentos de origem animal.' },
      { value: 'vegetarian', label: 'Dieta Vegetariana', objective: 'Dieta baseada em vegetais, sem carne.' },
      { value: 'flexitarian', label: 'Dieta Flexitariana', objective: 'Dieta vegetariana com consumo ocasional de carne.' },
      { value: 'pescatarian', label: 'Dieta Pescetariana', objective: 'Dieta vegetariana com inclusão de peixes.' },
      { value: 'paleo', label: 'Dieta Paleo', objective: 'Foco em alimentos naturais e integrais.' },
    ],
    healthSpecific: [
      { value: 'dash', label: 'Dieta DASH (Hipertensão)', objective: 'Reduzir a pressão arterial com alimentos ricos em nutrientes.' },
      { value: 'fodmap', label: 'Dieta FODMAP (Distúrbios Intestinais)', objective: 'Melhorar a digestão e reduzir desconfortos intestinais.' },
      { value: 'diabetes', label: 'Dieta para Diabetes', objective: 'Controlar os níveis de glicose no sangue.' },
      { value: 'low_sodium', label: 'Dieta Hipossódica', objective: 'Reduzir o consumo de sódio para saúde cardiovascular.' },
      { value: 'renal', label: 'Dieta Renal (Insuficiência Renal)', objective: 'Controlar nutrientes para a saúde dos rins.' },
    ],
  };


  const availableMeals = [
    { value: 'breakfast', label: 'Café da Manhã' },
    { value: 'morning_snack', label: 'Lanche da Manhã' },
    { value: 'lunch', label: 'Almoço' },
    { value: 'afternoon_snack', label: 'Lanche da Tarde' },
    { value: 'dinner', label: 'Jantar' },
    { value: 'supper', label: 'Ceia' },
  ];

  const getMealIcon = (mealName) => {
    switch (mealName.toLowerCase()) {
      case "café da manhã":
        return ico1;
      case "lanche da manhã":
        return ico2;
      case "almoço":
        return ico3;
      case "lanche da tarde":
        return ico4;
      case "jantar":
        return ico5;
      case "ceia":
        return ico6;
      default:
        return ico7; // Ícone padrão
    }
  };

  return (
    <>
      <h3>Buscar Dietas por Paciente</h3>

      <div className="getDietForm">
        <div className="getDiet-form-group">
          <h5 className="dietTitle">Paciente:</h5>
          <Select
            name="patient_id"
            options={patients.map((patient) => ({
              value: patient.person_id,
              label: patient.name,
            }))}
            noOptionsMessage={() => "Nenhuma opção disponível"}
            onChange={(selectedOption) => {
              setSelectedPatient(selectedOption);
              if (selectedOption) { // Verifica se selectedOption não é null
                dispatch(fetchDietByPatientId(selectedOption.value));
              } else {
                // Limpa as dietas quando o select é limpo
                dispatch(clearDiets());
              }
            }}
            classNamePrefix="custom-select"
            value={selectedPatient}
            placeholder="Selecione o paciente"
            isLoading={loadingPatients}
            isClearable
          />
          {errorPatients && <div className="error-message">Erro ao carregar pacientes: {errorPatients}</div>}
          <button type="button" className="returnDashboard" onClick={() => navigate("/home/dashboard")}>
            <MdHome />
          </button>
        </div>
      </div>

      <div className="getDietAccordion">
        {loadingDiets ? (
          <div>Carregando dietas...</div>
        ) : errorDiets ? (
          <div className="error-message">Erro ao carregar dietas: {errorDiets}</div>
        ) : selectedPatient && diets.length === 0 ? (
          <div>Nenhuma dieta encontrada para o paciente selecionado.</div>
        ) : (
          <>
            {diets && diets.length > 0 && (
              <h5>Dietas Anteriores</h5>
            )}
            <div className="getDietMain">
              {Array.isArray(diets) && diets.length > 0 ? (
                currentItems.map((diet) => (
                  <Accordion
                    key={diet.diet_id}
                    title={
                      <div className="row-getDietBox">
                        <div className="colDietBox">
                          <label className="labelDiet">Data</label>
                          <div className="rowDietBox">{formatDate(diet.created_at)}</div>
                        </div>
                        <div className="colDietBox">
                          <label className="labelDiet">Paciente</label>
                          <div className="rowDietBox">{selectedPatient ? selectedPatient.label : ""}</div>
                        </div>
                        <div className="colDietBox">
                          <label className="labelDiet">Dieta</label>
                          <div className="rowDietBox">{formatDietName(diet.name)}</div>
                        </div>
                        <div className="colDietBox">
                          <label className="labelDiet">Objetivo</label>
                          <div className="rowDietBox">{diet.objective}</div>
                        </div>
                        <div className="colDietBox">
                          <label className="labelDiet">Calorias</label>
                          <div className="rowDietBox">{diet.diet_total_calories} kcal</div>
                        </div>
                      </div>
                    }
                  >
                    {/* Conteúdo do Accordion (detalhes da dieta) */}
                    <div className="dietDetails">
                      {diet.meals && Array.isArray(diet.meals) ? diet.meals.map((meal, index) => (
                        <div key={index} className="mealDetail">
                          <div className="mealDetailTop">
                            <div>
                              <img className="mealIcon" src={getMealIcon(meal.name)} alt={meal.name} />
                            </div>

                            <div>
                              <h6>{meal.name} - {meal.time}</h6>
                              <h6><strong>Total Calorias:</strong> {meal.total_calories} kcal</h6>
                            </div>

                          </div>
                          <ul>
                            {meal.foods.map((food, foodIndex) => (
                              <li key={foodIndex}>
                                {food.quantity} {food.unit_measurement} - {food.food_name} - {food.calories} kcal
                              </li>
                            ))}
                          </ul>
                        </div>
                      )) : <p>nenhuma refeição localizada</p>}
                    </div>

                    {/* Botões de ação */}
                    <div className="dietActions">
                      <button
                        className="sendBtn"
                        onClick={() => {
                          const stateToSend = {
                            patient_id: selectedPatient?.value,
                            appointment_id: diet.appointment_id || null, // Adiciona o appointment_id se existir
                            consultation_id: diet.consultation_id || null // Adiciona o consultation_id se existir

                          };

                          navigate(`/home/diet/update/${diet.diet_id}`, {
                            state: stateToSend
                          });

                          console.log("Dados enviados para edição:", stateToSend);
                        }}
                      >
                        <MdEdit /> Editar
                      </button>




                      <button
                        className="backBtn"
                        onClick={() => handleDelete(diet.diet_id, diet.name)}
                      >
                        <MdDelete /> Excluir
                      </button>

                    </div>
                  </Accordion>
                ))
              ) : (
                <div></div>
              )}
            </div>
          </>
        )}

        {/* Paginação */}
        {diets.length > 0 && (
          <Pagination totalItems={diets.length} itemsPerPage={itemsPerPage} currentPage={currentPage} paginate={paginate} />
        )}
      </div >
    </>

  );
}

export default GetDietByPatientId;
